export const INTERNAL_LINKS = {
  HOME: '/',
  ABOUT: '/about',
  PROJECTS: '/projects',
  NOTFOUND: '/*',
  RESUME: '/Nakamoto_Andrew_Resume.pdf',
};

export const EXTERNAL_LINKS = {
  EMAIL: 'mailto:andrewsnakamoto@gmail.com',
  GITHUB: 'https://github.com/asn1814',
  LINKEDIN: 'https://www.linkedin.com/in/andrewnakamoto/',
}